import { ApiClient } from './apiClient';

let apiClientInstance: ApiClient | null = null;

export const createApiClient = (): ApiClient => {
    const baseUrl = import.meta.env.VITE_API_URL || 'https://localhost:32769';
    return new ApiClient(baseUrl);
};

export const setApiClientInstance = (client: ApiClient): void => {
    apiClientInstance = client;
};

export const getApiClient = (): ApiClient => {
    if (!apiClientInstance) {
        // Auto-initialize if not already set
        apiClientInstance = createApiClient();
    }
    return apiClientInstance;
};
